import type { UserManager } from 'oidc-client-ts'
import type { IAccessErrorEvent, IAccessUpdateEvent } from '~/types/access.types'
import { ACCESS_UPDATE_CODE } from '~/types/access.types'
import { dispatchTokenExpired } from '~/utils/event'

const updateEvent = ref<IAccessUpdateEvent>()
const errorEvent = ref<IAccessErrorEvent>()
const loaded = ref(false)
const sessionExpired = ref(false)
const sessionNotFound = ref(false)

export function useAccessEventHandler(oidc?: UserManager) {
  if (window.travelClient) {
    window.travelClient.on('error', (event: IAccessErrorEvent) => {
      errorEvent.value = event
    })

    window.travelClient.on('update', async (event: IAccessUpdateEvent) => {
      updateEvent.value = event

      if (event.update_code === ACCESS_UPDATE_CODE.TRAVEL_CLIENT_LOADED)
        loaded.value = true

      if (event.update_code === ACCESS_UPDATE_CODE.TRAVEL_CLIENT_SESSION_EXPIRED)
        sessionExpired.value = true

      if (event.update_code === ACCESS_UPDATE_CODE.SESSION_NOT_FOUND)
        sessionNotFound.value = true
    })
  }

  if (oidc) {
    oidc.events.addAccessTokenExpired(async () => {
      dispatchTokenExpired()
    })

    oidc.events.addAccessTokenExpiring(async () => {
      try {
        await oidc.signinSilent()
      }
      catch (error) {
        dispatchTokenExpired()
      }
    })
  }
}
export { errorEvent, loaded, sessionExpired, sessionNotFound, updateEvent }
